import React from "react";
import {
  genURL,
  gengetURLTEST,
  genpostURL,
  genpostURLTEST,
} from "./../_getjson";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Row, Col, Panel } from "react-bootstrap";
import PopupArcode from "../PopUp/PopUpArcode";
import PopUpOther2 from "./../PopUp/PopUpListINCOME";
import PopUpOther from "../PopUp/PopUpOther";
import PopUpOtherDB from "../PopUp/PopUpOther";
import { parseJwt } from "../parseJWT";
import PopUpSaveMoney from "../PopUp/PopUpSaveMoney";
import _popuplistreport from "../PopUp/PopUpSearch_debtor";
import PopUpReport from "../PopUp/_fromShow";
import { department, branch } from "../_source/checkUnit";
import Backdrop from "./../Components/CustomBackdrop/Barckdrop";
import axios from "axios";
import Checkdocgroup from "./../CustomFunction/Docgroup/Checkdocgroup";
import Chackdocno from "./../CustomFunction/Docno/GetDocno";
import ChackAr from "./../CustomFunction/Csar/GetAr";
import CheckUser from "./../CustomFunction/Csuser/GetUser";
import CheckBrabchname from "./../CustomFunction/Branch/Checkname";
import CheckDepartmentname from "./../CustomFunction/Department/Checkname";
import Snackbar from "./../Components/Snackbar/Snackbar";
import ErrorIcon from "@mui/icons-material/ErrorOutlineRounded";
import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import PopUpMultipletax from "./../PopUp/PopUpMultipletax";
import CheckTaxrate from "./../CustomFunction/Docgroup/CheckTaxrate";
// import FullScreenDialog from "./../PopUp/FullScreendialogs"
import SelectDatas from "./../PopUp/SelectData";
import MaterialUIPickers from "./../Components/CustomDatepicker/MaterialUIPickers";
import Topbar from "../Components/Customtopbar/Topbar";
import FullScreenDialog from "../PopUp/FullScreendialogs/FullScreen";
import Moment from "moment";
import CheckCsincome from "../CustomFunction/Checkcsincom/Checkname";
import CheckExpenses from "../CustomFunction/Checkcsexpenses/Checkname";
import Rechecked from "./Components/Rechecked";

import FullScreenDialognew from "../Components/CustomDialogs/Fullscreendialog";
import Repostview from "../Components/Reportview/Repostview";

import CheckCodeDocGroup from "../CustomFunction/Docgroup/CheckCodeDocGroup";
import "./csardeposit.css";
import CheckTaxgroup from "../CustomFunction/Docgroup/CheckTaxgroup";
import { Typography } from "@mui/material";
import InputTemplate from "../Components/CustomInput/InputTemplate/inputtemplate";
import CustomDatePicker from "../Components/CustomDatepicker/CustomDatePicker";
import { Grid } from "@mui/material";
import CustomARInput from "../Components/CustomARInput/CustomARInput";

require("./index.css");
const rowTable = 300;
const defaultcode = "0";
const listmenu = [
  ["บันทึกใบกำกับภาษีหลายใบ", "Inputmultipletax"],
  ["บันทึกรับเงิน", "SaveMoney"],
];

export default class Index extends React.Component {
  constructor(props) {
    super(props);
    console.log("componentconstructor");
    this.CustomerCode = React.createRef();
    this.CustomerName = React.createRef();
    this.Groupdata_code = React.createRef();
    this.Groupdata = React.createRef();
    this.DeliNumber = React.createRef();
    this.TAXNO = React.createRef();
    this.remark = React.createRef();
    this.Csuser_code = React.createRef();
    this.Csuser = React.createRef();
    this.Department_code = React.createRef();
    this.Department = React.createRef();
    this.Branch_code = React.createRef();
    this.Branch = React.createRef();
    this.WTAXAMOUNT = React.createRef();
    this.SumPrice = React.createRef();
    this.TaxPersen = React.createRef();
    this.TaxPrice = React.createRef();
    this.valueTax = React.createRef();
    this.ValueExcept = React.createRef();
    this.TotalPrice = React.createRef();
    this.PS_arcode = React.createRef();
    this.Contractno = React.createRef();
    this.Register = React.createRef();
    this.arname2 = React.createRef();
    this.Lastname = React.createRef();
    this.state = {
      SwitchPopupArcode: false,
      openFullScreenDialog: false,
      ARCode: "",
      selected: [],
      tableData: [],
      data1: "",
      selectRow: [],
      DocType: [],
      SGstatus: true,
      DisInput: true,
      mstremark: "-",
      tfdocPrint: "",
      CHLOOP: 0,
      loading: "none",
      Expcode: "",
      Groupdata_txt: "",
      Department_txt: "",
      Branch_txt: "",
      codeGroup: 9,
      openBackdrop: false,
      autoClose: 3600,
      color: "warning",
      messagealert: "",
      siteCodeUser1: "",
      dataMultipletax: "",
      setMultipletax: "",
      Docdate1: "",
      Groupcode: "",
      Groupname: "",
      Docno: "",
      Remark: "",
      PriceType_code: defaultcode,
      checkenableInput: [],
      PROJECT: "",
      AmountPayable: 0,
      Incomesum: 0,
      Expensessum: 0,
      Billsum: 0,
      Creditsum: 0,
      CHARGEAMOUNT: 0,
      DataSavemoney: "",
      //บันทึกรับเงิน เงินสด/เงินโอน
      CashReceipt: 0,
      BOOKNO: 0,
      BANKAMOUNT: 0,
      BANKEXPEND: 0,
      Remarkcase: "",
      //บันทึกรับเงิน เช็ครับ/ตั๋วเงิน
      tbbill: "",
      //บันทึกรับเงิน บัตรเครดิต
      tbcedit: "",
      //บันทึกรับเงิน รายได้อื่นๆ
      tbincome: "",
      //บันทึกรับเงิน ค่าใช้จ่ายอื่นๆ
      tbexpenses: "",
      reporturl: "",
      formPrintdata: "",
      resrecheckeddata: [],
      DueCustOrder: "",
    };
  }

  Cal_Price = () => {
    var Sumamount1 = 0; // รวมจำนวนเงิน
    var Sumamount2 = 0; // มูลค่ายกเว้น
    var Totalamount = 0; //มูลค่ารวมภาษี
    var Debtamount = 0; // รวมทั้งสิ้น
    var Taxrate = 0;
    if (this.TaxPersen.current.value) {
      Taxrate = parseFloat(this.TaxPersen.current.value).toFixed(2);
    }
    this.TaxPersen.current.value = parseFloat(Taxrate).toFixed(2);
    // var Taxamount = Sumamount1 / ((Taxrate / 100) + 1);
    var TaxPersen = Number(this.TaxPersen.current.value);
    //----------แยกเลือกประเภทการขาย-----------------
    var ty_code = String(this.state.PriceType_code);

    var CTaxamount = 0;
    for (
      var i = 0;
      i < this.state.tableData.length && this.state.tableData[i].T_Amount;
      i++
    ) {
      console.log(this.state.tableData[i].T_Amount);
      if (this.state.tableData[i].BTN_T === "1") {
        if (ty_code === "0") {
          Sumamount1 += parseFloat(this.state.tableData[i].T_Amount);
          CTaxamount = 100;
          Debtamount = Sumamount1 + (TaxPersen * Sumamount1) / CTaxamount;
          Totalamount = this.SumPrice.current.value * 1 + CTaxamount;
        } else if (ty_code === "1") {
          Sumamount1 += parseFloat(this.state.tableData[i].T_Amount);
          CTaxamount = 100 + TaxPersen;
          Debtamount += parseFloat(this.state.tableData[i].T_Amount);
          Totalamount = this.SumPrice.current.value * 1;
        } else if (ty_code === "2") {
          Sumamount1 += parseFloat(this.state.tableData[i].T_Amount);
          CTaxamount = 0;
          Debtamount += parseFloat(this.state.tableData[i].T_Amount);
          Totalamount += parseFloat(this.state.tableData[i].T_Amount);
        }
      } else {
        console.log(ty_code);
        if (ty_code === "0") {
          CTaxamount = 100;
          Sumamount2 += parseFloat(this.state.tableData[i].T_Amount);
          console.log(Sumamount2, this.state.tableData[i].T_Amount);
          Debtamount += parseFloat(this.state.tableData[i].T_Amount);
          Totalamount = 0;
        } else if (ty_code === "1") {
          CTaxamount = 100 + TaxPersen;
          Sumamount2 += parseFloat(this.state.tableData[i].T_Amount);
          Debtamount += parseFloat(this.state.tableData[i].T_Amount);
          Totalamount = 0;
        } else if (ty_code === "2") {
          CTaxamount = 0;
          Sumamount2 += parseFloat(this.state.tableData[i].T_Amount);
          Debtamount += parseFloat(this.state.tableData[i].T_Amount);
          Totalamount = 0;
        }
      }
    }
    if (ty_code === "2") {
      this.TaxPrice.current.value = "0.00";
    } else if (Sumamount1 !== 0.0) {
      console.log(TaxPersen, Sumamount1, CTaxamount, ty_code);
      this.TaxPrice.current.value = parseFloat(
        (TaxPersen * Sumamount1) / CTaxamount
      ).toFixed(2);
    } else {
      this.TaxPrice.current.value = "0.00";
    }
    console.log(Sumamount1);
    this.valueTax.current.value = parseFloat(Sumamount1).toFixed(2);
    this.setState({ Sumamount1: parseFloat(Sumamount1).toFixed(2) });
    this.TotalPrice.current.value = parseFloat(Debtamount).toFixed(2);
    this.SumPrice.current.value = parseFloat(Sumamount1).toFixed(2);
    /* มูลค่ายกเว้น  */
    this.ValueExcept.current.value = parseFloat(Sumamount2).toFixed(2);
    this.setState({ AmountPayable: this.TotalPrice.current.value });
  };
  Cal_Price1 = (e) => {
    if (e.key === "Enter" && e.target.value !== "") {
      this.Cal_Price();
    }
  };
  addData = (data) => {
    switch (data.target.name) {
      case "data1":
        this.setState({ data1: data.target.value });
        break;
      default:
        break;
    }
  };
  componentWillMount() {
    console.log("componentWillMount");
  }
  componentDidMount() {
    console.log("componentDidMount");

    //เช็คเปิดปิด textbox
    this.setState({
      checkenableInput: JSON.parse(localStorage.getItem("checkoftxt")),
    });

    let SITECODESTR = parseJwt(localStorage.getItem("Token"));
    this.setState({
      siteCodeUser: SITECODESTR.User.SITECODE,
      openFullScreenDialog: false,
    });
    this.setState({ siteCodeUser1: SITECODESTR.User.CODE });
    this.onAddValue("Csuser", SITECODESTR.User.CODE);
    this.setRow(rowTable);
    this.onAddValue("Branch", SITECODESTR.User.SITECODE);
    let mid = new URLSearchParams(location.search).get("mid");
    this.loadFromindb(mid);
  }

  loadFromindb = async (mid) => {
    //โหลดฟอร์มสำหรับพิมพ์ใบเสร็จ
    let url = `reportmanage/reportform/${mid}?`;
    console.log("res.data", genURL(url));
    let res = await axios.get(genURL(url));
    console.log("ressssss", res.data);
    if (res.data.length > 0) {
      await this.setState({ reporturl: res.data[0].pathname });
      await this.setState({ formPrintdata: res.data });
    }
  };
  setRow = (count) => {
    var data = [];
    for (var i = 0; i <= count - 1; i++) {
      data[i] = { C0: i + 1 };
    }
    this.setState({ tableData: data });
  };
  SelectSetData = async (type, data, rowIndex) => {
    switch (type) {
      case "PriceType":
        this.setState({ PriceType_code: await String(data) });
        this.Cal_Price();
        break;
      case "Calendar1":
        this.setState({ Docdate: data });
        break;
      // case "PROJECT":
      //   this.setState({ PROJECT: data })
      //   break
      case "PROJECT":
        //textproject
        if (rowIndex === "") {
          this.setState({ PROJECT: data });
          //settableproject
          for (let i = 0; i < this.state.tableData.length; i++) {
            if (this.state.tableData[i].T_Code) {
              this.state.tableData[i].PROJECT = data;
            }
          }
        }
        // tableproject
        if (rowIndex !== "") {
          this.state.tableData[Number(rowIndex)].PROJECT = data;
        }
        break;
      default:
        break;
    }
  };
  SetPopup = (data) => {
    this.setState({ PopUpTYpe: data });
    // this.setState({ showPopupOT: !this.state.showPopupOT });
    this.setState({ typeFullScreenDialog: "Search_Table" });
    //open
    this.setState({ openFullScreenDialog: true });
    //title
    this.setState({ titleFullScreenDialog: "ค้นหารหัสรายได้อื่นๆ-Income" });
  };
  SetPopup1 = (e) => {
    this.setState({ PopUpTYpe: e });
    // this.setState({ showPopupDB: !this.state.showPopupDB });
    this.setState({ typeFullScreenDialog: e + "tb" });
    //open
    this.setState({ openFullScreenDialog: true });
    if (e === "Department") {
      this.setState({ titleFullScreenDialog: "เลือกรายการ-csdepartment" });
    }
    if (e === "Branch") {
      this.setState({ titleFullScreenDialog: "เลือกรายการ-cssite" });
    }
  };
  Switch_PopupArcode = (e) => {
    // this.setState({ SwitchPopupArcode: !this.state.SwitchPopupArcode });
    //ชื่อ
    this.setState({ typeFullScreenDialog: e });
    //open
    this.setState({ openFullScreenDialog: true });
    //title
    this.setState({ titleFullScreenDialog: "ค้นหาลูกค้า-AR" });
  };
  Switch_OtherPopup = (e) => {
    this.setState({ OtPopupType: e });
    // this.setState({ SwitchOtherPopup: !this.state.SwitchOtherPopup });
    //ชื่อ
    this.setState({ typeFullScreenDialog: e });
    //open
    this.setState({ openFullScreenDialog: true });
    if (e === "Groupdata") {
      this.setState({ titleFullScreenDialog: "เลือกรายการ-csdocgroup" });
    }
    if (e === "Department") {
      this.setState({ titleFullScreenDialog: "เลือกรายการ-csdepartment" });
    }
    if (e === "Branch") {
      this.setState({ titleFullScreenDialog: "เลือกรายการ-cssite" });
    }
  };
  Get_PopUparcode = (
    data1,
    data2,
    data3,
    data4,
    data5,
    data6,
    data7,
    data8,
    data9,
    data10,
    data11,
    data12
  ) => {
    this.CloseDialog(false);
    this.CustomerCode.current.value = data1;
    this.CustomerName.current.value = data2;
    this.arname2.current.value = data12;
    this.Lastname.current.value = data9;
    this._pricetype(data4);
  };
  Get_PopUpOther = async (val) => {
    this.CloseDialog(false);
    var data = val.split("|");
    console.log(data);
    for (var i = 0; i < data.length; i++) {
      data[i] = data[i].trim();
    }
    switch (this.state.OtPopupType) {
      case "Groupdata":
        console.log("dddd", data);
        this.Groupdata_code.current.value = data[0];
        this.Groupdata.current.value = data[1];
        this.setState({ Groupdata_txt: data[1] });
        this.setState({ Groupcode: data[0] });
        this.setState({ Groupname: data[1] });
        await Chackdocno(data[0], "CSARDEPOSIT")
          .then(async (result1) => {
            console.log(result1);
            if (result1 !== undefined) {
              this.DeliNumber.current.value = await result1;
              this.setState({ Docno: result1 });
            } else {
              this.DeliNumber.current.value = "";
            }
          })
          .finally((_) => {
            CheckTaxrate(data[0], "CSARDEPOSIT").then((result) => {
              console.log("sssss", result);
              this.TaxPersen.current.value = result;
              // this.setState({ taxgroup:})
            });
            CheckTaxgroup(data[0], "CSARDEPOSIT").then((result) => {
              console.log("CheckTaxgroup", result);
              this.setState({
                taxgroup: result,
              });
            });
          })
          .catch((err) => {
            this.DeliNumber.current.value = "";
            console.log(err);
          });
        break;
      case "Department":
        this.Department_code.current.value = await data[0];
        this.Department.current.value = await data[1];
        this.setState({ Department_txt: data[1] });

        break;
      case "Branch":
        this.Branch_code.current.value = await data[0];
        this.Branch.current.value = await data[1];
        this.setState({ Branch_txt: data[1] });
        break;
      default:
        break;
    }
  };
  // GetMultipletax = (data) => {
  //   this.setState({ setMultipletax: data })
  // };
  Get_PopUpOther2 = (data) => {
    this.CloseDialog(false);
    var split_data = data.split("|");
    switch (this.state.PopUpTYpe) {
      // ค้นหาตาราง
      case "T_Expcode":
        let col = this.state.tableData;
        let j = this.state.rowChk_wtb;
        for (var i = 0; i < col.length; i++) {
          if (
            col[i].T_Code !== split_data[0] &&
            (col[i].T_Code === undefined || col[i].T_Code === "")
          ) {
            col[j].T_Code = split_data[0];
            col[j].T_List = split_data[1];
            col[j].T_Explain = "";
            // Auto แผนก
            if (this.Department.current.value !== "") {
              col[j].T_Department = this.Department.current.value;
              col[j].T_Department_Code = this.Department_code.current.value;
            } else {
              col[j].T_Department = "";
              col[j].T_Department_Code = "";
            }
            // Auto สาขา
            if (this.Branch.current.value !== "") {
              col[j].T_Branch = this.Branch.current.value;
              col[j].T_Branch_Code = this.Branch_code.current.value;
            } else {
              col[j].T_Branch = "";
              col[j].T_Branch_Code = "";
            }
            col[i].PROJECT = this.state.PROJECT;
            col[j].BTN_T = split_data[4];
            col[j].BTN_W = split_data[3];
            col[j].T_Amount = (0.0).toFixed(2);
            break;
          } else if (col[i].T_Code === split_data[0]) {
            break;
          }
        }
        this.setState({ tableData: [...col] });
        break;
      default:
        break;
    }
  };
  Get_PopUpDB = (data) => {
    this.CloseDialog(false);
    var split_data = data.split("|");
    switch (this.state.PopUpTYpe) {
      case "Department":
        let arrData2 = this.state.tableData;
        arrData2[this.state.rowChk_wtb].T_Department_Code = split_data[0];
        arrData2[this.state.rowChk_wtb].T_Department = split_data[1];
        this.setState({ tableData: arrData2 });
        break;
      case "Branch":
        let arrData3 = this.state.tableData;
        arrData3[this.state.rowChk_wtb].T_Branch_Code = split_data[0];
        arrData3[this.state.rowChk_wtb].T_Branch = split_data[1];
        this.setState({ tableData: arrData3 });
        break;
      default:
        break;
    }
    // this.setState({ showPopupOT: !this.state.showPopupOT });
  };
  PopUpOtherClose = (data) => {
    this.setState({ showPopupOT: !this.state.showPopupOT });
  };
  PopUpOtherClose1 = () => {
    this.setState({ showPopupDB: !this.state.showPopupDB });
  };
  PopUpMultipletax = () => {
    this.setState({ SwitchMultipletax: !this.state.SwitchMultipletax });
  };
  _cellButton(cell, row, enumObject, rowIndex) {
    var BTN = this.state.tableData[rowIndex].BTN_Code;
    var btnShow = "";
    switch (BTN) {
      case 1:
        btnShow = (
          <div
            style={{ cursor: "pointer", fontSize: "14px" }}
            onClick={this.SetPopup.bind(null, "T_Expcode")}
          >
            <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
          </div>
        );
        break;
      default:
        btnShow = <i className=""></i>;
        break;
    }
    return <div>{btnShow}</div>;
  }
  _cellButton2(cell, row, enumObject, rowIndex) {
    var BTN = this.state.tableData[rowIndex].BTN_Department;
    var btnShow = "";
    switch (BTN) {
      case 1:
        btnShow = (
          <div
            style={{ cursor: "pointer", fontSize: "14px" }}
            onClick={this.SetPopup1.bind(null, "Department")}
          >
            <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
          </div>
        );
        break;
      default:
        btnShow = <i className=""></i>;
        break;
    }
    return <div>{btnShow}</div>;
  }
  _cellButton3(cell, row, enumObject, rowIndex) {
    var BTN = this.state.tableData[rowIndex].BTN_Branch;
    var btnShow = "";
    switch (BTN) {
      case 1:
        btnShow = (
          <div
            style={{ cursor: "pointer", fontSize: "14px" }}
            onClick={this.SetPopup1.bind(null, "Branch")}
          >
            <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
          </div>
        );
        break;
      default:
        btnShow = <i className=""></i>;
        break;
    }
    return <div>{btnShow}</div>;
  }
  cellcheckbok = (cell, row, enumObject, rowIndex) => {
    var BTN = this.state.tableData[rowIndex].BTN_T;
    var btnShow;
    switch (BTN) {
      case "0":
        btnShow = (
          <span>
            <i
              className="far fa-square "
              onClick={this.Update_Status.bind(null, rowIndex, "1")}
              style={{ paddingTop: "7px" }}
            ></i>
          </span>
        );
        break;
      case "1":
        btnShow = (
          <span>
            <i
              className="far fa-check-square"
              onClick={this.Update_Status.bind(null, rowIndex, "0")}
              style={{ paddingTop: "7px" }}
            ></i>
          </span>
        );
        break;
      default:
        btnShow = (
          <span>
            <i className=""> </i>
          </span>
        );
    }
    return <div>{btnShow}</div>;
  };
  cellcheckbok2 = (cell, row, enumObject, rowIndex) => {
    var BTN = this.state.tableData[rowIndex].BTN_W;
    var btnShow;
    switch (BTN) {
      case "0":
        btnShow = (
          <span>
            <i
              className="far fa-square "
              onClick={this.Update_Status2.bind(null, rowIndex, "1")}
              style={{ paddingTop: "7px" }}
            ></i>
          </span>
        );
        break;
      case "1":
        btnShow = (
          <span>
            <i
              className="far fa-check-square"
              onClick={this.Update_Status2.bind(null, rowIndex, "0")}
              style={{ paddingTop: "7px" }}
            ></i>
          </span>
        );
        break;
      default:
        btnShow = (
          <span>
            <i className=""> </i>
          </span>
        );
    }
    return <div>{btnShow}</div>;
  };
  Update_Status = (Row, Status) => {
    var dataArray = this.state.tableData;
    dataArray[Row].BTN_T = Status;
    this.setState({ tableData: dataArray });
    setTimeout(() => {
      this.Cal_Price();
    }, 100);
  };
  Update_Status2 = (Row, Status) => {
    var dataArray = this.state.tableData;
    dataArray[Row].BTN_W = Status;
    this.setState({ tableData: dataArray });
  };
  onClickDocNo = async () => {
    if (!this.Groupdata_code.current.value) {
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "รหัสกลุ่มข้อมูลไม่ถูกต้อง" });
    }
    if (this.Groupdata_code.current.value) {
      var url =
        "CSMAXDOC/MAXDOC?tablename=CSARDEPOSIT&code=" +
        this.Groupdata_code.current.value.trim();
      console.log(genURL(url));
      await axios
        .get(genURL(url), { timeout: 3600 })
        .then((res) => {
          if (res.data.maxdoc.length > 0) {
            this.DeliNumber.current.value = res.data.maxdoc;
          } else {
            this.DeliNumber.current.value = "";
          }
        })
        .catch((error) => {
          console.log(error);
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "ไม่สามารถโหลดข้อมูลได้" });
          this.setState({ openBackdrop: false });
        });
    } else {
      this.DeliNumber.current.value = "";
    }
  };
  onRowClick = (row, col, id) => {
    let C_row = this.state.tableData;
    this.setState({ cellValue: row.T_Code });
    // จำนวนเต็มเวลาคลิก
    let T_Amount = row.T_Amount;
    if (col === 5 && T_Amount !== "" && T_Amount !== undefined) {
      row.T_Amount = Number(T_Amount);
    }
    // คลิกแผนก
    if (col === 6) {
      this.setState({ Department_TH: C_row[id].T_Department });
      C_row[id].T_Department = C_row[id].T_Department_Code;
    }
    // คลิกสาขา
    if (col === 9) {
      this.setState({ Branch_TH: C_row[id].T_Branch });
      C_row[id].T_Branch = C_row[id].T_Branch_Code;
    }
    // หาจากล่างขึ้นบน
    var Pr = this.state.tableData;
    for (let i = 0; i < this.state.tableData.length; i++) {
      Pr[i].BTN_Code = 2;
      Pr[i].BTN_Department = 2;
      Pr[i].BTN_Branch = 2;
    }
    this.setState({ tableData: Pr });
    var j = 0;
    for (var i = this.state.tableData.length - 1; i >= 0; i--) {
      if (!this.state.tableData[i].T_Code) {
        j = i;
      }
    }
    if (
      (col === 1 && j === id) ||
      (col === 1 && row.T_Code !== undefined && row.T_Code !== "")
    ) {
      this.setState({ Colcode: true });
      row.BTN_Code = 1;
      row.BTN_Department = 2;
      row.BTN_Branch = 2;
    } else if (col === 6 && row.T_Code) {
      row.BTN_Code = 2;
      row.BTN_Department = 1;
      row.BTN_Branch = 2;
    } else if (col === 9 && row.T_Code) {
      row.BTN_Code = 2;
      row.BTN_Department = 2;
      row.BTN_Branch = 1;
    } else {
      this.setState({ Colcode: false });
      this.setState({ Colall: false });
    }
    if (row.T_Code !== "" && row.T_Code !== undefined) {
      this.setState({ Colall: true });
    }
    this.setState({ rowChk_wtb: row.C0 - 1 });
  };
  EnterAddDataC1 = (i, data) => {
    var split_data = data.split("|");
    var row = this.state.tableData;
    row[i].BTN_Code = 1;
    row[i].T_Code = split_data[0];
    row[i].T_List = split_data[1];
    row[i].T_Explain = "";
    // Auto แผนก
    if (this.Department.current.value !== "") {
      row[i].T_Department = this.Department.current.value;
      row[i].T_Department_Code = this.Department_code.current.value;
    } else {
      row[i].T_Department = "";
      row[i].T_Department_Code = "";
    }
    // Auto สาขา
    if (this.Branch.current.value !== "") {
      row[i].T_Branch = this.Branch.current.value;
      row[i].T_Branch_Code = this.Branch_code.current.value;
    } else {
      row[i].T_Branch = "";
      row[i].T_Branch_Code = "";
    }
    row[i].PROJECT = this.state.PROJECT;
    row[i].BTN_T = split_data[2];
    row[i].BTN_W = "0";
    row[i].T_Amount = (0.0).toFixed(2);
    this.setState({ tableData: row });
  };
  /* OnBlur */
  EnterAddDataC5 = (RowId) => {
    setTimeout(() => {
      var dataArray = this.state.tableData;
      dataArray[RowId].BTN_Department = 1;
      let arrData = this.state.tableData;
      arrData[RowId].T_Department_Code = this.state.C_TDepartment;
      arrData[RowId].T_Department = this.state.T_Department;
      /*   arrData[RowId].BTN_T = this.state.tableData[RowId].BTN_T;
        arrData[RowId].BTN_W = this.state.tableData[RowId].BTN_W; */
      arrData[RowId].BTN_Department = 2;
      this.setState({ tableData: arrData });
    }, 300);
  };
  EnterAddDataC6 = (RowId) => {
    setTimeout(() => {
      var dataArray = this.state.tableData;
      dataArray[RowId].BTN_Branch = 1;
      let arrData = this.state.tableData;
      arrData[RowId].T_Branch = this.state.T_Sitecode;
      arrData[RowId].T_Branch_Code = this.state.C_TSitecode;
      /* arrData[RowId].BTN_T = this.state.tableData[RowId].BTN_T;
       arrData[RowId].BTN_W = this.state.tableData[RowId].BTN_W; */
      arrData[RowId].BTN_Branch = 2;
      this.setState({ tableData: arrData });
    }, 300);
  };
  afterSaveCell = async (row, cellName, cellValue) => {
    let S_row = this.state.tableData;
    let i = row.C0 - 1;
    // ทศนิยม 2 ตำแหน่ง ปริมาณ  ลด
    let T_Amount = row.T_Amount;
    if (cellName === "T_Amount" && T_Amount !== "") {
      row.T_Amount = parseFloat(T_Amount).toFixed(2);
    }
    var cellValue1 = this.state.cellValue;
    if (cellName === "T_Code" && cellValue !== "" && cellValue1 !== cellValue) {
      var url = "CSINCOME/GETCODE?Code=" + cellValue + "&user=";
      console.log(genURL(url));
      await axios
        .get(genURL(url), { timeout: 3600 })
        .then((res) => {
          if (res.data.length === 1) {
            this.setState({ PopUpTYpe: "T_Expcode" });
            var reData =
              res.data[0].CODE +
              "|" +
              res.data[0].MYNAMETH +
              "|" +
              res.data[0].CALCTAX;
            this.EnterAddDataC1(i, reData);
          } else {
            this.setState({ C_Expcode: "" });
            this.setState({ Expcode: "" });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (
      cellName === "T_Code" &&
      cellValue === "" /* && this.state.tableData[row.C0].T_Code === "" */
    ) {
      setTimeout(() => {
        this.SetRowNull();
      }, 500);
    }
    if (cellName === "T_Department" && cellValue !== "") {
      CheckDepartmentname(cellValue)
        .then(async (result) => {
          console.log("sss", result);
          if (result !== "") {
            row.T_Department_Code = cellValue;
            row.T_Department = await result;
            await this.reload();
          } else {
            this.setState({ opensnackbar: true });
            this.setState({ color: "warning" });
            this.setState({ icon: ErrorIcon });
            this.setState({ messagealert: "ไม่พบข้อมูล" });
            row.T_Department_Code = "";
            row.T_Department = "";
          }
        })
        .catch((error) => {
          row.T_Department_Code = "";
          row.T_Department = "";
          console.log(error);
        });
    }
    if (cellName === "T_Branch" && cellValue !== "") {
      CheckBrabchname(cellValue)
        .then(async (result) => {
          if (result !== "") {
            row.T_Branch_Code = cellValue;
            row.T_Branch = await result;
            await this.reload();
          } else {
            this.setState({ opensnackbar: true });
            this.setState({ color: "warning" });
            this.setState({ icon: ErrorIcon });
            this.setState({ messagealert: "ไม่พบข้อมูล" });
            row.T_Branch_Code = "";
            row.T_Branch = "";
          }
        })
        .catch((error) => {
          row.T_Branch_Code = "";
          row.T_Branch = "";
          console.log(error);
        });
    }
    // ลบแผนก
    if (cellName === "T_Department" && cellValue === "") {
      S_row[i].T_Department_Code = "";
      this.setState({ tableData: S_row });
    }
    // ลบสาขา
    if (cellName === "T_Branch" && cellValue === "") {
      S_row[i].T_Branch_Code = "";
      this.setState({ tableData: S_row });
    }
    if (cellName === "T_Amount" && cellValue !== "") {
      console.log("จำนวนเงิน");
      setTimeout(() => {
        this.Cal_Price();
      }, 30);
    }
  };
  reload = () => {
    var data = this.state.tableData;
    this.setState({ tableData: data });
  };
  SetRowNull = () => {
    var col = this.state.tableData;
    var NewCol = [];
    var j = 0;
    for (var i = 0; i < col.length; i++) {
      if (col[i].T_Code) {
        NewCol[j] = col[i];
        NewCol[j].C0 = j + 1;
        j++;
      }
    }
    for (var i = j; i < col.length; i++) {
      NewCol[j] = { C0: j + 1 };
      j++;
    }
    this.setState({ tableData: NewCol });
  };
  int_format = (int) => {
    var re = 0;
    if (int) {
      re = parseFloat(int).toFixed(2);
    } else {
      re = parseFloat(re).toFixed(2);
    }
    return re;
  };
  AddDataRow = () => {
    var j = 0;
    for (var i = 0; i <= rowTable - 1; i++) {
      var data = this.state.tableData;
      if (this.state.tableData[i].T_Code !== "") {
        data[j] = {
          C0: j + 1,
          T_Code: this.state.tableData[i].T_Code,
          T_List: this.state.tableData[i].T_List,
          T_Explain: this.state.tableData[i].T_Explain,
          T_Amount: this.state.tableData[i].T_Amount,
          T_Department: this.state.tableData[i].T_Department,
          T_Branch: this.state.tableData[i].T_Branch,
          BTN_T: this.state.tableData[i].BTN_T,
          BTN_W: this.state.tableData[i].BTN_W,
          C9: this.state.tableData[i].C9,
          C10: this.state.tableData[i].C10,
          T_Department_Code: this.state.tableData[i].T_Department_Code,
          T_Branch_Code: this.state.tableData[i].T_Branch_Code,
          SB: this.state.tableData[i].SB,
        };
        j++;
      }
    }
    for (var i = j; i <= rowTable - 1; i++) {
      var data = this.state.tableData;
      data[i] = {
        C0: i + 1,
        T_Code: "",
        T_List: "",
        T_Explain: "",
        T_Amount: "",
        T_Department: "",
        T_Branch: "",
        BTN_T: "",
        BTN_W: "",
        C9: "",
        C10: "",
        T_Department_Code: "",
        T_Branch_Code: "",
        SB: "0",
      };
    }

    this.setState({ tableData: data });
    this.Cal_Price();
  };
  //สเตตัส/เงินที่ต้องขำระ/เงินสด/เงินโอน/ตั๋วเงิน/รวมตั๋วเงิน/บัตรเครดิต/ค่าใช้จ่ายรายได้อื่นๆ/รวมรายได้อื่นๆ
  _get_PopUpSaveMoney = async (
    status,
    AmountPayable,
    CashReceipt,
    moneytransfer,
    Bill,
    Billsum,
    Credit,
    Creditsum,
    Income,
    Incomesum,
    Expenses,
    Expensessum,
    CHARGEAMOUNT,
    CHARGEPAY1,
    CHARGEPAY2,
    tbBill,
    tbCredit,
    tbotherincome,
    tbexpenses,
    //เพิ่มเติม
    arrayBill,
    arrayCredit,
    arrayexpenses,
    arrayotherincome
  ) => {
    var split = moneytransfer.split("|");
    var BOOKNO = split[0];
    var BANKAMOUNT = split[1];
    var BANKEXPEND = split[2];
    var Remarkcase = split[3] ? split[3] : "";
    await this.setState({
      CashReceipt: CashReceipt, //เงินสด
      BOOKNO: BOOKNO, //เลขบัญชี
      BANKAMOUNT: BANKAMOUNT, //ยอดเงินโอน
      BANKEXPEND: BANKEXPEND, //ค่าธรรมเนียมจ่ายหักบัญชี
      Remarkcase: Remarkcase,
      Bill: Bill,
      Billsum: Billsum,
      Credit: Credit,
      Creditsum: Creditsum,
      Income: Income,
      Incomesum: Incomesum,
      Expenses: Expenses,
      Expensessum: Expensessum,
      CHARGEAMOUNT: CHARGEAMOUNT,
      arrayBill: arrayBill,
      arrayCredit: arrayCredit,
      arrayexpenses: arrayexpenses,
      arrayotherincome: arrayotherincome,
    });
    if (status === "accress") {
      var PAYMENT = AmountPayable;
      if (PAYMENT <= 0) {
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "ไม่มียอดชำระ" });
        return;
      } else {
        this.saveData();
      }
    } else if (status === "close") {
      // setdefult เช็ครับ/ตั๋วเงิน
      this.setState({ tbBill: tbBill });
      // setdefult บัตรเครดิต
      this.setState({ tbcredit: tbCredit });
      // setdefult รายได้อื่นๆ
      this.setState({ tbincome: tbincome });
      // setdefult ค่าใช้จ่ายอื่นๆ
      this.setState({ tbexpenses: tbexpenses });
    }
  };
  saveData = async () => {
    if (!this.state.Docdate) {
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "วันที่เอกสาร" });
      return;
    }
    const parameter = new URLSearchParams();
    const parameter2 = new URLSearchParams();
    var dataTT = [];
    var depItem = [];
    for (
      var i = 0;
      i < this.state.tableData.length && this.state.tableData[i].T_Code;
      i++
    ) {
      if (this.state.tableData[i].T_Code !== "") {
        dataTT[i] = {
          T_Code: this.state.tableData[i].T_Code,
          T_List: this.state.tableData[i].T_List,
          T_Explain: this.state.tableData[i].T_Explain,
          T_Amount: this.state.tableData[i].T_Amount,
          T_Department: this.state.tableData[i].T_Department,
          T_Department_Code: this.state.tableData[i].T_Department_Code,
          T_Branch: this.state.tableData[i].T_Branch,
          T_Branch_Code: this.state.tableData[i].T_Branch_Code,
          BTN_T: this.state.tableData[i].BTN_T,
          BTN_W: this.state.tableData[i].BTN_W,
          PROJECT: this.state.tableData[i].PROJECT,
        };
        depItem.push(dataTT[i]);
      }
    }
    /* Success */
    parameter.append("listitem", JSON.stringify(depItem));
    let Multipletaxdata = [];
    let Multipletaxdatanew = [];
    let BEFORETAX = 0;
    let TAXAMOUNT = 0;
    for (let i = 0; i < this.state.setMultipletax.length; i++) {
      if (this.state.setMultipletax[i].Taxno) {
        BEFORETAX += Number(this.state.setMultipletax[i].Beforetax);
        TAXAMOUNT += Number(this.state.setMultipletax[i].Taxamount);
        Multipletaxdatanew[i] = {
          Arcode: this.state.setMultipletax[i].Arcode,
          Arname: this.state.setMultipletax[i].Arname,
          Beforetax: this.state.setMultipletax[i].Beforetax,
          Code: this.state.setMultipletax[i].Code,
          Remark: this.state.setMultipletax[i].Remark,
          Taxamount: this.state.setMultipletax[i].Taxamount,
          Taxdate: this.state.setMultipletax[i].Taxdate,
          Taxno: this.state.setMultipletax[i].Taxno,
          Totalamount: this.state.setMultipletax[i].Totalamount,
          Zerotax: this.state.setMultipletax[i].Zerotax,
        };
        Multipletaxdata.push(Multipletaxdatanew[i]);
      }
    }

    let ArDepositData = {
      DueCustOrder: this.state.DueCustOrder,
      test: "",
    };

    parameter.append("Multipletax", JSON.stringify(Multipletaxdata));

    // parameter.append("bill", !this.state.Bill ? "" : JSON.stringify(this.state.Bill));
    // add new 21/10/2556 เพิ่มการทำงานในส่วนคอมม่า

    parameter.append("CSRECCHQ", JSON.stringify(this.state.arrayBill));
    parameter.append(
      "CHEQUEAMOUNT",
      !this.state.Billsum ? 0 : this.state.Billsum
    );
    parameter.append("CSRECCREDIT", JSON.stringify(this.state.arrayCredit));
    parameter.append(
      "CREDITAMOUNT",
      !this.state.Creditsum ? 0 : this.state.Creditsum
    );
    parameter.append(
      "CSRECINCOME",
      JSON.stringify(this.state.arrayotherincome)
    );
    parameter.append(
      "INCOMEAMOUNT",
      !this.state.Incomesum ? 0 : this.state.Incomesum
    );
    parameter.append(
      "otherexpenseslist",
      JSON.stringify(this.state.arrayexpenses)
    );

    // end  new 21/10/2556 เพิ่มการทำงานในส่วนคอมม่า

    parameter.append(
      "CSRECEXPENSE",
      !this.state.Expenses ? "" : this.state.Expenses
    );
    parameter.append("CREATEUSER", localStorage.getItem("Username"));
    parameter.append("ARNAME", this.CustomerName.current.value);
    parameter.append("ARCODE", this.CustomerCode.current.value);
    parameter.append("Docgroup", this.Groupdata_code.current.value);
    parameter.append("DOCDATE", this.state.Docdate);
    parameter.append("DOCNO", this.DeliNumber.current.value);
    parameter.append("REMARK", this.remark.current.value);
    parameter.append("TAXTYPE", this.state.PriceType_code);
    parameter.append("DEPARTMENT", this.Department_code.current.value);
    parameter.append("SITECODE", this.Branch_code.current.value);
    parameter.append("CURRENCYCODE", "TH");
    parameter.append("SUMAMOUNT1", this.SumPrice.current.value);
    parameter.append(
      "TAXRATE",
      typeof this.TaxPersen.current.value !== undefined
        ? this.TaxPersen.current.value
        : 0
    );
    parameter.append("TAXAMOUNT", this.TaxPrice.current.value);
    parameter.append("TOTALAMOUNT", this.valueTax.current.value);
    parameter.append("SUMAMOUNT2", this.ValueExcept.current.value);
    parameter.append("DEBTAMOUNT", this.TotalPrice.current.value);
    parameter.append(
      "BATHSUMAMOUNT1",
      Number(this.valueTax.current.value - this.TaxPrice.current.value)
    );
    parameter.append("BATHSUMAMOUNT2", this.ValueExcept.current.value);
    parameter.append("DOCGROUP", this.Groupdata_code.current.value);
    parameter.append("CASHAMOUNT", this.state.CashReceipt);
    parameter.append("BOOKNO", this.state.BOOKNO);
    parameter.append("BOOKDESC", this.state.Remarkcase);
    parameter.append("BANKAMOUNT", this.state.BANKAMOUNT);
    parameter.append("BANKEXPEND", this.state.BANKEXPEND);
    parameter.append("PS_arcode", this.PS_arcode.current.value); //UserFile ARCODE
    parameter.append("Register", this.Register.current.value);
    parameter.append("arname2", this.arname2.current.value);
    parameter.append("lastname", this.Lastname.current.value);
    parameter.append("Contractno", this.Contractno.current.value);
    parameter.append("computername", "computername");
    parameter.append(
      "CHEQUEAMOUNT",
      !this.state.Billsum ? 0 : this.state.Billsum
    );
    parameter.append(
      "EXPENDAMOUNT",
      !this.state.Expensessum ? 0 : this.state.Expensessum
    );
    parameter.append("PROJECT", this.state.PROJECT),
      parameter.append("ArDepositData", JSON.stringify(ArDepositData));
    var Uststus = true;
    for (var pair of parameter.entries()) {
      console.log(pair);
      if (pair[1] === "" && (pair[0] === "ARCODE" || pair[0] === "ARNAME")) {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกรหัสลูกค้า" });
        this.CustomerCode.current.focus();
        return;
      } else if (pair[1] === "" && pair[0] === "Docgroup") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกกลุ่มข้อมูล" });

        return;
      } else if (pair[1] === "" && pair[0] === "DEPARTMENT") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกแผนก" });
        return;
      } else if (pair[1] === "" && pair[0] === "SITECODE") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกสาขา" });

        return;
      } else if (pair[1] === "" && pair[0] === "remark") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกหมายเหตุ" });
        this.remark.current.focus();
        return;
      } else if (this.state.codeGroup === 0) {
        if (pair[1] === "" && pair[0] === "PS_arcode") {
          Uststus = false;
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "กรุณากรอกรหัสลูกค้า" });

          return;
        } else if (pair[1] === "" && pair[0] === "contractno") {
          Uststus = false;
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "กรุณากรอกเลขที่สัญญา" });

          return;
        } else if (pair[1] === "" && pair[0] === "Register") {
          Uststus = false;
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "กรุณากรอกเลขทะเบียน" });

          return;
        } else if (pair[1] === "" && pair[0] === "arname2") {
          Uststus = false;
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "กรุณากรอกชื่อลูกค้า" });

          return;
        } else if (pair[1] === "" && pair[0] === "Lastname") {
          Uststus = false;
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "กรุณากรอกนามสกุลลูกค้า" });
          return;
        }
      }
    }

    if (Uststus === true) {
      // this.setState({ openBackdrop: true })

      //  let url = "/Save?user=";
      // await axios.post(genpostURLTEST("/Save?user="), parameter).then(async res => {
      await axios
        .post(genpostURL("CSARDEPOSIT/Save?user="), parameter)
        .then(async (res) => {
          //  console.log("sdeews", res);
          if (res.data.status === "success") {
            this.setState({ opensnackbar: true });
            this.setState({ color: "success" });
            this.setState({ icon: ErrorIcon });
            this.setState({ messagealert: "บันทึกสำเร็จ" });
            setTimeout(() => {
              // this.ResetThisPage();
              this.setState({ openBackdrop: false });
              this._printReport(res.data.docno);
            }, 100);
          } else {
            this.setState({ opensnackbar: true });
            this.setState({ color: "warning" });
            this.setState({ icon: ErrorIcon });
            this.setState({
              messagealert: "บันทึกไม่สำเร็จ" + res.data.status,
            });
            this.setState({ openBackdrop: false });
          }
        })
        .catch((error) => {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "เกิดข้อผิดพลาด" + error });
          this.setState({ openBackdrop: false });
        });
      setTimeout(() => {
        this.setState({ openFullScreenDialog: false });
      }, 1500);
    }
  };

  ReplacePage = (e) => {
    this.setState({ openBackdrop: false });
    window.location.replace(e);
  };
  //-------------------ลบแถว
  setdelete_load = () => {
    this.setState({ CSdelete: "" });
    this.setState({ CSdeletes: false });
    this.setState({ CSdelete_yes: false });
  };

  setdelete_no = () => {
    this.setState({ CSdelete: "far fa-square" });
    this.setState({ CSdeletes: false });
    this.setState({ CSdelete_yes: false });
  };
  setdelete_yes = () => {
    this.setState({ CSdelete: "fas fa-trash-alt" });
    this.setState({ CSdeletes: true });
    this.setState({ CSdelete_yes: true });
  };
  _chkload = (cell, row, enumObject, rowIndex) => {
    return (
      <div>
        <i id={"load" + rowIndex}>{rowIndex + 1}</i>
      </div>
    );
  };
  deleterowall = (Row, Status) => {
    if (this.state.CSdeletes === false) {
      var dataArray = this.state.tableData;
      for (
        var i = 0;
        i < this.state.tableData.length && this.state.tableData[i].T_Code;
        i++
      ) {
        dataArray[i].SB = "1";
        this.setState({ tableData: dataArray });
      }
      if (i > 0) {
        this.setdelete_yes();
        this.setState({ CSdeletes: !this.state.CSdeletes });
      }
    }

    if (this.state.CSdelete_yes === true) {
      var dataArray = this.state.tableData;
      for (
        var i = 0;
        i < this.state.tableData.length && this.state.tableData[i].T_Code;
        i++
      ) {
        if (this.state.tableData[i].SB === 1) {
          dataArray[i].T_Code = "";
        }
      }
      this.setState({ tableData: dataArray });
      this.AddDataRow();
      this.setdelete_load();
    }
  };

  Update_Status_del = (Row, Status) => {
    if (Status === 0) {
      var dataArray = this.state.tableData;
      dataArray[Row].T_Code = "";
      this.setState({ tableData: dataArray });
      this.AddDataRow();

      for (
        var i = 0;
        i < this.state.tableData.length && this.state.tableData[i].T_Code;
        i++
      ) {}
      if (i <= 0) {
        this.setdelete_load();
      }
    } else {
      var dataArray = this.state.tableData;
      dataArray[Row].SB = Status;
      this.setState({ tableData: dataArray });

      var chk_all = 0;
      var chk_all_y = 0;
      for (
        var i = 0;
        i < this.state.tableData.length && this.state.tableData[i].T_Code;
        i++
      ) {
        chk_all_y = chk_all_y + 1;
        if (this.state.tableData[i].SB === 1) {
          chk_all = chk_all + 1;
        }
      }

      if (chk_all === chk_all_y && chk_all_y > 0) {
        this.setdelete_yes();
      }
    }
  };
  Switch_PopUpSaveMoney = (e) => {
    console.log("testdddd");
    this.setState({ openFullScreenDialog: false });
  };
  _saveConnection = () => {
    var table = this.state.tableData;

    for (var i = 0; i < table.length && table[i].T_Code; i++) {
      if (table[i].BTN_T === "1" && table[i].T_Code !== "") {
        if (this.state.setMultipletax.length <= 0) {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({
            messagealert:
              "ให้กำหนดรายการภาษีมูลค่าเพิ่มก่อน(ใบกำกับภาษีหลายใบ)...!",
          });
          return;
        }
      }
      console.log("table[i].T_Code", table[i].T_Code);
      if (table[i].T_Code === "") {
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({
          messagealert: "กรุณาเพิ่มรายการรับเงินล่วงหน้า/เงินมัดจำ",
        });
        return;
      }
      if (table[i].T_Code && table[i].T_Department_Code === "") {
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกแผนก...!" });
        return;
      }
      if (
        table[i].T_Code &&
        table[i].T_Department_Code !== this.Department_code.current.value
      ) {
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "แผนกไม่ตรงกันกรุณาตรวจสอบ...!" });
        return;
      }
    }

    // เช็คภาษี

    if (this.state.PriceType_code === "1") {
      if (this.TaxPrice.current.value === "0.00") {
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "ให้ใส่ภาษีมูลค่าเพิ่มก่อน...!" });
        return;
      } else if (this.state.setMultipletax.length <= 0) {
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({
          messagealert:
            "ให้กำหนดรายการภาษีมูลค่าเพิ่มก่อน(ใบกำกับภาษีหลายใบ)...!",
        });
        return;
      }
    }
    var row = this.state.setMultipletax;

    // if (this.state.setMultipletax.length <= 0 && Number(this.state.PriceType_code) < 2) {
    //   this.setState({ opensnackbar: true })
    //   this.setState({ color: "warning" })
    //   this.setState({ icon: ErrorIcon })
    //   this.setState({ messagealert: "ให้กำหนดภาษีมูลค่าเพิ่มก่อน...!" })
    //   return
    // }
    if (row) {
      var total = "";
      for (let i = 0; i < row.length && row[i].Taxno; i++) {
        total += Number(row[i].Totalamount);
      }
      var parmtotal = Number(this.valueTax.current.value);
      console.log(Number(total), "===", parmtotal);
      if (Number(total) !== parmtotal) {
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "มูลค่าภาษีขายไม่เท่ากับหน้าบิลขาย" });
        return;
      }
    }
    if (this.CustomerCode.current.value === "") {
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "กรุณากรอกรหัสลูกค้า" });
      this.CustomerCode.current.focus();
      return;
    }
    if (this.Groupdata_code.current.value === "") {
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "กรุณากรอกกลุ่มข้อมูล" });

      this.Groupdata.current.focus();
      return;
    }
    if (this.state.SiteCode_code === "") {
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "กรุณากรอกสาขา" });

      this.Branch.current.focus();
      return;
    }
    if (this.Department_code.current.value === "") {
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "กรุณากรอกแผนก" });
      this.Department.current.focus();
      return;
    }
    if (this.remark.current.value === "") {
      this.remark.current.focus();
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "กรุณากรอกหมายเหตุ" });

      return;
    }
    // if (this.Groupdata_code.current.value.substr(0, 2) === "IA" && this.Department_code.current.value !== "00") {
    //   this.setState({ opensnackbar: true })
    //   this.setState({ color: "warning" })
    //   this.setState({ icon: ErrorIcon })
    //   this.setState({ messagealert: "แผนกไม่ถูกต้อง" })
    //   return;
    // }
    // if (this.state.PriceType_code === "0" && this.TaxPersen.current.value !== "0.00") {
    //   this.setState({ opensnackbar: true })
    //   this.setState({ color: "warning" })
    //   this.setState({ icon: ErrorIcon })
    //   this.setState({ messagealert: "ให้กำหนดรายการภาษีมูลค่าเพิ่มก่อน" })
    //   this.TaxPersen.current.focus()
    //   return;
    // }

    console.log("this.TaxPersen.current.value", this.TaxPersen.current.value);

    if (
      this.TotalPrice.current.value === "0.00" ||
      this.TotalPrice.current.value === ""
    ) {
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "ให้ใส่จำนวนเงินก่อน" });
      return;
    } else if (this.state.codeGroup === "0") {
      if (this.PS_arcode.current.value === "") {
        this.PS_arcode.current.focus();
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกรหัสลูกค้า" });
        return;
      } else if (this.Contractno.current.value === "") {
        this.Contractno.current.focus();
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกเลขที่สัญญา" });

        return;
      } else if (this.Register.current.value === "") {
        this.Register.current.focus();
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกเลขทะเบียน" });

        return;
      } else if (this.arname2.current.value === "") {
        this.arname2.current.focus();
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกชื่อลูกค้า" });

        return;
      } else if (this.Lastname.current.value === "") {
        this.Lastname.current.focus();
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกนามสกุลลูกค้า" });
        return;
      } else {
        this.setState({
          titleFullScreenDialog: "บันทึกรับเงิน",
          openFullScreenDialog: true,
          typeFullScreenDialog: "SaveMoney",
        });
      }
    }
    var BalanceIn =
      Number(this.state.AmountPayable) +
      Number(this.state.Incomesum) -
      (Number(this.state.CashReceipt) +
        Number(this.state.BANKAMOUNT) +
        Number(this.state.Expensessum) +
        Number(this.state.BANKEXPEND) +
        Number(this.state.Billsum) +
        Number(this.state.Creditsum) -
        Number(this.state.CHARGEAMOUNT));
    console.log(BalanceIn);
    if (BalanceIn === 0) {
      this.saveData();
    } else {
      this.setState({
        titleFullScreenDialog: "บันทึกรับเงิน",
        openFullScreenDialog: true,
        typeFullScreenDialog: "SaveMoney",
      });
    }
  };

  Switch_Report = (e) => {
    this.setState({ SwitchReport: !this.state.SwitchReport });
  };
  convertimeps = (date) => {
    if (date) {
      var myDate = new Date(date);
      var date = myDate.getDate();
      if (myDate.getDate() < 10) {
        date = "0" + myDate.getDate();
      }
      var month = myDate.getMonth() + 1;
      if (myDate.getMonth() + 1 < 10) {
        month = "0" + (myDate.getMonth() + 1);
      }
      var year = myDate.getFullYear() + 543;
      return date + "/" + month + "/" + year;
    } else {
      return "";
    }
  };
  setdefaultmoney = async (Docno) => {
    var urlcarecchq =
      "CSRECCHQ/Search?Docno=" + Docno + "&Tablename=CSARDEPOSIT";
    console.log(genURL(urlcarecchq));
    await axios
      .get(genURL(urlcarecchq), { timeout: 3600 })
      .then(async (res) => {
        console.log(res.data);
        var Bill = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length + 9; i++) {
            if (i < res.data.length) {
              Bill[i] = {
                C0: i + 1,
                C1: res.data[i].CHEQUENO, //เลขที่เซ็ค/ตั่วเงิน
                C2: res.data[i].CHQPAY, //ยอดชำระหนี้
                C2_1: res.data[i].BANKCODE, // ธนาคาร
                C3: res.data[i].BANKBRANCH, // สาขาธนาคาร
                C4: Moment(res.data[i].DUEDATE, "YYYY-MM-DD")
                  .add(543, "year")
                  .format("DD/MM/YYYY"), //วันที่ขาย
                C5: res.data[i].CHQAMOUNT, //มูลค่าเซ็ค/ตั่วเงิน
                C6: res.data[i].BANKBRANCH,
                C7: res.data[i].REMARK,
              };
            } else {
              Bill[i] = {
                C0: i + 1,
                C1: "",
                C2: "",
                C2_1: "",
                C3: "",
                C4: "",
                C5: "",
                C6: "",
                C7: "",
              };
            }
          }
        } else {
          Bill = "";
        }
        this.setState({ tbbill: Bill });
      });
    var urlcareccredit =
      "CSRECCREDIT/Search?Docno=" + Docno + "&Tablename=CSARDEPOSIT";
    console.log(genURL(urlcareccredit));
    await axios
      .get(genURL(urlcareccredit), { timeout: 3600 })
      .then(async (res) => {
        console.log(res.data);
        var Credit = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length + 9; i++) {
            if (i < res.data.length) {
              Credit[i] = await {
                C0: i + 1,
                C1: res.data[i].CREDITNO,
                C2: res.data[i].CREDITAMOUNT,
                C3_1: res.data[i].CREDITTYPE,
                C4: res.data[i].CREDITPAY,
                C5: res.data[i].CHARGE,
                C5_1: res.data[i].CHARGEAMOUNT,
                C6_1: res.data[i].CHARGEPAY,
                C7: res.data[i].CONFIRMNO,
                C8: res.data[i].REMARK,
              };
            } else {
              Credit[i] = await {
                C0: i + 1,
                C1: "",
                C2: "",
                C3_1: "",
                C4: "",
                C5: "",
                C5_1: "",
                C6_1: "",
                C7: "",
                C8: "",
              };
            }
          }
        } else {
          Credit = "";
        }
        this.setState({ tbcredit: Credit });
      });
    var urlcareccredit =
      "CSRECINCOME/Search?Docno=" + Docno + "&Tablename=CSARDEPOSIT";
    console.log(genURL(urlcareccredit));
    await axios
      .get(genURL(urlcareccredit), { timeout: 3600 })
      .then(async (res) => {
        console.log(res.data);
        var tbincome = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length + 9; i++) {
            if (i < res.data.length) {
              let checkname;
              await CheckCsincome(res.data[i].INCOME).then(async (name) => {
                checkname = name;
              });
              tbincome[i] = await {
                C0: i + 1,
                C1: res.data[i].INCOME,
                BTN: "delect",
                C2: checkname,
                C3: res.data[i].REMARK,
                C4: res.data[i].AMOUNT,
              };
            } else {
              tbincome[i] = await {
                C0: i + 1,
                C1: "",
                BTN: 1,
                C2: "",
                C3: "",
                C4: "",
              };
            }
          }
        } else {
          tbincome = "";
        }
        this.setState({ tbincome: tbincome });
      });
    var urlcareccredit =
      "CSRECEXPENSE/Search?Docno=" + Docno + "&Tablename=CSARDEPOSIT";
    console.log(genURL(urlcareccredit));
    await axios
      .get(genURL(urlcareccredit), { timeout: 3600 })
      .then(async (res) => {
        console.log(res.data);
        var tbexpenses = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length + 9; i++) {
            if (i < res.data.length) {
              let checkname;
              await CheckExpenses(res.data[i].EXPENSE).then(async (name) => {
                checkname = name;
              });
              tbexpenses[i] = await {
                C0: i + 1,
                C1: res.data[i].EXPENSE,
                BTN: "delect",
                C2: checkname,
                C3: res.data[i].REMARK,
                C4: res.data[i].AMOUNT,
              };
            } else {
              tbexpenses[i] = await {
                C0: i + 1,
                C1: "",
                BTN: 1,
                C2: "",
                C3: "",
                C4: "",
              };
            }
          }
        } else {
          tbexpenses = "";
        }
        this.setState({ tbexpenses: tbexpenses });
      });
  };

  reCheckData = async (type, val, fix) => {
    switch (type) {
      case "Groupdata":
        CheckCodeDocGroup(val, "CSARDEPOSIT")
          .then((result) => {
            console.log("result Groupdata", result);
            this.Groupdata_code.current.value = val;
            this.Groupdata.current.value = result;
            this.setState({ Groupdata_txt: result });
            this.setState({ Groupcode: val });
            this.setState({ Groupname: result });
          })
          .finally((_) => {
            CheckTaxrate(val, "CSARDEPOSIT").then(async (result) => {
              this.TaxPersen.current.value = await result;
              //  this.Taxrate.current.value = result
            });
          });
        break;
    }
  };

  _reCHK = async (RowData) => {
    this.setState({ openBackdrop: true });
    console.log("RowData", RowData);
    this.CloseDialog(false);
    this.setState({ SwitchSearchDoc: false });
    this.setState({ _saveStatus: "disabled" });
    this.setdefaultmoney(RowData[0].docNo);
    var url = "CSARDEPOSIT/Getdatamain?DOCNO=" + RowData[0].docNo;
    console.log(genURL(url));
    await axios
      .get(genURL(url), { timeout: 3600 })
      .then(async (res) => {
        if (res) {
          this.setState({ resrecheckeddata: res.data });
          this.CustomerCode.current.value = res.data[0].ARCODE;
          this.CustomerName.current.value = res.data[0].ARNAME;
          this.setState({ Docdate: this.convertimeps(res.data[0].DOCDATE) });
          //  this.onAddValue("Groupdata", res.data[0].DOCGROUP, "Y")
          await this.reCheckData("Groupdata", res.data[0].DOCGROUP, true);
          this.onAddValue("Csuser", res.data[0].USERCODE);
          this.DeliNumber.current.value = res.data[0].DOCNO;
          this.remark.current.value = res.data[0].REMARK;
          this.onAddValue("Branch", res.data[0].SITECODE);
          this.onAddValue("Department", res.data[0].DEPARTMENT);
          this._pricetype(res.data[0].TAXTYPE);
          this.TaxPersen.current.value = res.data[0].TAXRATE;
          this.TaxPrice.current.value = res.data[0].TAXAMOUNT;
          this.SumPrice.current.value = res.data[0].SUMAMOUNT1;
          this.ValueExcept.current.value = res.data[0].SUMAMOUNT2;
          this.TotalPrice.current.value = res.data[0].DEBTAMOUNT;
          this.valueTax.current.value = res.data[0].TOTALAMOUNT;
          this.PS_arcode.current.value = res.data[0].arcode2;
          this.Contractno.current.value = res.data[0].Contractno;
          this.Register.current.value = res.data[0].Register;
          this.arname2.current.value = res.data[0].arname2;
          this.Lastname.current.value = res.data[0].Lastname;
          // setdefult เงินสด/เงินโอน
          this.setState({ CashReceipt: res.data[0].CASHAMOUNT });
          this.setState({ BOOKNO: res.data[0].BOOKNO });
          this.setState({ BANKAMOUNT: res.data[0].BANKAMOUNT });
          this.setState({ BANKEXPEND: res.data[0].BANKEXPEND });
          this.setState({ Remarkcase: res.data[0].BOOKDESC });
        }
      })
      .catch((error) => {
        console.log(error);
      });
    var url5 = "CSARDEPOSIT/Getdatasub?DOCNO=" + RowData[0].docNo;
    console.log(genURL(url5));
    axios
      .get(genURL(url5), { timeout: 3600 })
      .then(async (ressub) => {
        var data = this.state.tableData;
        for (var i = 0; i < ressub.data.length; i++) {
          data[i].T_Code = ressub.data[i].EXPCODE;
          data[i].T_List = ressub.data[i].EXPNAME;
          data[i].T_Explain = ressub.data[i].REMARK;
          data[i].T_Amount = ressub.data[i].AMOUNT;
          console.log(ressub.data[i].CALWTAX);
          data[i].BTN_T = String(ressub.data[i].CALCTAX);
          data[i].BTN_W = String(ressub.data[i].CALCWTAX);
          data[i].T_Department_Code = ressub.data[i].DEPARTMENT;
          data[i].PROJECT = ressub.data[i].PROJECT;
          data[i].T_Department = await department(ressub.data[i].DEPARTMENT);
          data[i].T_Branch_Code = ressub.data[i].SITECODE;
          data[i].T_Branch = await branch(ressub.data[i].SITECODE);
        }
        await this.setState({ tableData: data });
        await this.Cal_Price();
      })
      .catch((error) => {
        console.log(error);
      });
    // await this.Cal_Price();
    await this.setState({ openBackdrop: false });
    // ภาษีหลายใบ
    this.setState({ dataMultipletax: [] });
  };

  _printReport = (docno) => {
    try {
      if (formPrintdata.length > 1) {
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({
          messagealert:
            "กรุณาตรวจสอบลิงค์ From จำนวนลิงค์ฟอร์มมี " + formPrintdata.length,
        });
        return;
      }
    } catch (error) {}
    if (this.state.reporturl !== "") {
      this.setState({
        openReportFullScreenDialog: true,
        titleReportFullScreenDialog: "พิมพ์ใบเสร็จรับเงินมัดจำ",
        urlsend: `${process.env.REACT_APP_REPORTURL}${this.state.reporturl}&j_username=${process.env.REACT_APP_REPORTUSER}&j_password=${process.env.REACT_APP_REPORTPASSWORD}&output=${process.env.REACT_APP_REPORTTYPE}&api_key=${process.env.REACT_APP_REPORTAPIKEY}&docno=${docno}`,
      });
    } else {
      this.ReplacePage(window.location.pathname + location.search);
    }
  };
  _GetFilename(url) {
    if (url) {
      var m = url.toString().match(/.*\/(.+?)\./);
      if (m && m.length > 1) {
        return m[1];
      }
    }
    return "";
  }
  switchshowform = (e) => {
    this.setState({ showform: !this.state.showform });
  };
  onSearch = (e) => {
    var data = this.state.tableData;
    for (var i = 0; i < data.length; i++) {
      data[i].T_Code = "";
      data[i].T_List = "";
      data[i].T_Explain = "";
      data[i].T_Amount = "";
      data[i].T_Department = "";
      data[i].C5_insert = "";
      data[i].T_Branch = "";
      data[i].BTN_T = "";
      data[i].BTN_W = "";
      data[i].C9 = "";
      data[i].discount = "";
      data[i].C10 = "";
      this.setState({ tableData: data });
      /* this.Cal_Price(); */
    }
  };
  onAddValue = async (type, value, Fix) => {
    if (value) {
      switch (type) {
        case "Groupdata":
          Checkdocgroup(value, "CSARDEPOSIT", Fix)
            .then(async (result) => {
              console.log("Checkdocgroup", result);
              if (result !== "") {
                this.Groupdata_code.current.value = value;
                this.Groupdata.current.value = result;
                this.setState({ Groupdata_txt: result });
                this.setState({ Groupcode: value });
                this.setState({ Groupname: result });
                if (Fix !== "Y") {
                  await Chackdocno(value, "CSARDEPOSIT")
                    .then((result1) => {
                      if (result1 !== "") {
                        this.DeliNumber.current.value = result1;
                      } else {
                        this.DeliNumber.current.value = "";
                      }
                    })
                    .catch((err) => {
                      this.DeliNumber.current.value = "";
                      console.log(err);
                    });
                }
              } else {
                this.setState({ opensnackbar: true });
                this.setState({ color: "warning" });
                this.setState({ icon: ErrorIcon });
                this.setState({ messagealert: "ไม่พบข้อมูล" });
                this.Groupdata_code.current.value = "";
                this.Groupdata.current.value = "";
                this.setState({ Groupdata_txt: "" });
                this.DeliNumber.current.value = "";
              }
            })
            .finally(() => {
              CheckTaxrate(value, "CSARDEPOSIT").then((result) => {
                console.log("sssss", result);
                if (Fix !== "Y") {
                  this.TaxPersen.current.value = result;
                }
              });
              CheckTaxgroup(value, "CSARDEPOSIT").then((result) => {
                console.log("CheckTaxgroup", result);
                this.setState({
                  taxgroup: result,
                });
              });
            })
            .catch((err) => {
              this.Groupdata_code.current.value = "";
              this.Groupdata.current.value = "";
              this.setState({ Groupdata_txt: "" });
              this.DeliNumber.current.value = "";
              console.log(err);
            });
          break;
        case "CustomerCode":
          await ChackAr(value)
            .then((result) => {
              console.log(result);
              if (result !== "") {
                let data = result.split("|");
                this.CustomerCode.current.value = value;
                this.CustomerName.current.value = data[0];
                this.arname2.current.value = data[2];
                this.Lastname.current.value = data[3];
                this._pricetype(data[5]);
              } else {
                this.setState({ opensnackbar: true });
                this.setState({ color: "warning" });
                this.setState({ icon: ErrorIcon });
                this.setState({ messagealert: "ไม่พบข้อมูล" });
                this.CustomerCode.current.value = "";
                this.CustomerName.current.value = "";
                this.arname2.current.value = "";
                this.Lastname.current.value = "";
              }
            })
            .catch((err) => {
              this.CustomerCode.current.value = "";
              this.CustomerName.current.value = "";
              this.arname2.current.value = "";
              this.Lastname.current.value = "";
              console.log(err);
            });
          break;
        case "Csuser":
          await CheckUser(value)
            .then(async (result) => {
              if (result !== "") {
                this.Csuser_code.current.value = await value;
                this.Csuser.current.value = await result;
              } else {
                this.setState({ opensnackbar: true });
                this.setState({ color: "warning" });
                this.setState({ icon: ErrorIcon });
                this.setState({ messagealert: "ไม่พบข้อมูล" });
                this.Csuser_code.current.value = "";
                this.Csuser.current.value = "";
              }
            })
            .catch((err) => {
              this.Csuser_code.current.value = "";
              this.Csuser.current.value = "";
              console.log(err);
            });
          break;
        case "Department":
          await CheckDepartmentname(value)
            .then((result) => {
              if (result !== "") {
                this.Department_code.current.value = value;
                this.Department.current.value = result;
                this.setState({ Department_txt: result });
              } else {
                this.setState({ opensnackbar: true });
                this.setState({ color: "warning" });
                this.setState({ icon: ErrorIcon });
                this.setState({ messagealert: "ไม่พบข้อมูล" });
                this.Department_code.current.value = "";
                this.Department.current.value = "";
                this.setState({ Department_txt: "" });
              }
            })
            .catch((err) => {
              this.Department_code.current.value = "";
              this.Department.current.value = "";
              this.setState({ Department_txt: "" });
              console.log(err);
            });
          break;
        case "Branch":
          await CheckBrabchname(value)
            .then((result) => {
              if (result !== "") {
                this.Branch_code.current.value = value;
                this.Branch.current.value = result;
                this.setState({ Branch_txt: result });
              } else {
                this.setState({ opensnackbar: true });
                this.setState({ color: "warning" });
                this.setState({ icon: ErrorIcon });
                this.setState({ messagealert: "ไม่พบข้อมูล" });
                this.Branch_code.current.value = "";
                this.Branch.current.value = "";
                this.setState({ Branch_txt: "" });
              }
            })
            .catch((err) => {
              this.Branch_code.current.value = "";
              this.Branch.current.value = "";
              this.setState({ Branch_txt: "" });
              console.log(err);
            });
          break;
        default:
          break;
      }
    }
  };

  Chackdoc = () => {
    Chackdocno(this.Groupdata_code.current.value, "CSARDEPOSIT")
      .then(async (result1) => {
        if (result1 !== undefined) {
          this.DeliNumber.current.value = await result1;
        } else {
          this.DeliNumber.current.value = "";
        }
      })
      .catch((err) => {
        this.DeliNumber.current.value = "";
        console.log(err);
      });
  };
  onClick = (e) => {
    if (e.target.value !== "") {
      switch (e.target.name) {
        case "Groupdata":
          this.Groupdata.current.value = this.Groupdata_code.current.value;
          break;
        case "Department":
          this.Department.current.value = this.Department_code.current.value;
          break;
        case "Branch":
          this.Branch.current.value = this.Branch_code.current.value;
          break;
        default:
          break;
      }
    }
  };
  onKeyDown = (e) => {
    if (e.key === "Enter") {
      if (e.target.name === "Groupdata") {
        this.onAddValue("Groupdata", e.target.value);
      }
      if (e.target.name === "CustomerCode") {
        this.onAddValue("CustomerCode", e.target.value);
      }
      if (e.target.name === "Department") {
        this.onAddValue("Department", e.target.value);
      }
      if (e.target.name === "Branch") {
        this.onAddValue("Branch", e.target.value);
      }
    }
  };
  onChange = (e) => {
    switch (e.target.name) {
      case "Groupdata":
        if (e.target.value === "") {
          this.setState({ Groupdata_txt: "" });
          this.Groupdata_code.current.value = "";
          this.DeliNumber.current.value = "";
        }
        break;
      case "CustomerCode":
        if (e.target.value === "") {
          this.CustomerCode.current.value = "";
          this.CustomerName.current.value = "";
        }
        break;
      case "Department":
        if (e.target.value === "") {
          this.setState({ Department_txt: "" });
          this.state.Department_txt = "";
        }
        break;
      case "Branch":
        if (e.target.value === "") {
          this.setState({ Branch_txt: "" });
          this.Branch_code.current.value = "";
        }
        break;
      default:
        break;
    }
  };
  onBlur = async (e) => {
    console.log("ssssssssssssssssssssssssssssssss", e.target.value);
    if (e.target.name === "Groupdata") {
      this.Groupdata.current.value = this.state.Groupdata_txt;
      this.Groupdata_code.current.value = e.target.value;
      await CheckTaxgroup(e.target.value, "CSARDEPOSIT").then((result) => {
        console.log("CheckTaxgroup", result);
        this.setState({
          taxgroup: result,
        });
      });
    }
    if (e.target.name === "Department") {
      this.Department.current.value = this.state.Department_txt;
    }
    if (e.target.name === "Branch") {
      this.Branch.current.value = this.state.Branch_txt;
    }
  };
  // CloseDialog = (e) => {
  //   this.setState({ openFullScreenDialog: e })
  // }
  ReturnData = (e) => {
    console.log("ReturnData", e);
    this.setState({ openFullScreenDialog: e[0] });
    if (e[1]) {
      this.setState({ setMultipletax: [...e[1]] });
    }
    if (e[2]) {
      this.setState({ Docdate1: e[2] });
    }
    if (e[3]) {
      this.setState({ Groupcode: e[3] });
    } else if (e[3] === "") {
      this.setState({ Groupcode: "" });
    }
    if (e[4]) {
      this.setState({ Groupname: e[4] });
    } else if (e[4] === "") {
      this.setState({ Groupname: "" });
    }
    if (e[5]) {
      this.setState({ Docno: e[5] });
    } else if (e[5] === "") {
      this.setState({ Docno: "" });
    }
    if (e[6]) {
      this.CustomerCode.current.value = e[6];
    }
    if (e[7]) {
      this.CustomerName.current.value = e[7];
    }
    if (e[8]) {
      this.setState({ Remark: e[8] });
    } else if (e[8] == "") {
      this.setState({ Remark: "" });
    }
  };
  openDialog = () => {
    var Data = [];
    Data = {
      from: "CSARDEPOSIT",
      userSite: this.state.siteCodeUser,
      defult: this.state.setMultipletax,
      Docdate: this.state.Docdate1,
      Groupdata_code: this.state.Groupcode,
      // Groupdata_code: "",
      Groupdata: this.state.Groupname,
      // Groupdata: "",
      DeliNumber: this.state.Docno,
      Code: this.CustomerCode.current.value,
      Name: this.CustomerName.current.value,
      Remark: this.state.Remark,
      TaxPersen: this.TaxPersen.current.value,
      Total: this.valueTax.current.value,
    };
    console.log("DataDataDataDataData", Data);

    this.setState({ dataMultipletax: Data });
    if (this.state.Docdate === "") {
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "กรุณากรอกวันที่ก่อน ...!" });
      return;
    }
    if (this.CustomerCode.current.value === "") {
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "กรุณากรอกข้อมูลเจ้าหนี้ก่อน ...!" });
      return;
    }
    if (this.CustomerName.current.value === "") {
      this.setState({ opensnackbar: true });
      this.setState({ color: "warning" });
      this.setState({ icon: ErrorIcon });
      this.setState({ messagealert: "กรุณากรอกข้อมูลเจ้าหนี้ก่อน ...!" });
      return;
    }
    this.setState({ openFullScreenDialog: true });
    this.setState({ titleFullScreenDialog: "เลือกใบกำกับภาษีหลายใบ" });
    this.setState({ typeFullScreenDialog: "Inputmultipletax" });
  };
  _pricetype = async (Texttype) => {
    let strTexttype = String(Texttype);
    // this.setState({ defaultselect: strTexttype })
    this.setState({ PriceType_code: await strTexttype });
    this.Cal_Price();
  };
  onClickTopbar = (e) => {
    switch (e) {
      case "save":
        this._saveConnection();
        break;
      case "new":
        this.ReplacePage(window.location.pathname + location.search);
        break;
      case "print":
        this._printReport(null);
        break;
      case "search":
        this.onSearch();
        // this.setState({ SwitchSearchDoc: true });
        //ชื่อ
        this.setState({ typeFullScreenDialog: e });
        //open
        this.setState({ openFullScreenDialog: true });
        //title
        this.setState({ titleFullScreenDialog: "บันทึกรับเงินมัดจำ" });
        break;
      case "Inputmultipletax":
        if (this.state.taxgroup !== "") {
          this.openDialog();
        } else {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "กรุณารอสักครู่กำลังโหลดกลุ่มภาษี" });
        }

        break;
      case "SaveMoney":
        this.SaveMoney();
        break;
      default:
        break;
    }
  };
  SaveMoney = () => {
    var DataSavemoney = {
      // setdefult เงินสด/เงินโอน
      CashReceipt: this.state.CashReceipt,
      Bookno: this.state.BOOKNO,
      Bankamount: this.state.BANKAMOUNT,
      Bankexpend: this.state.BANKEXPEND,
      Remark: this.state.Remarkcase,
      // setdefult เช็ครับ/ตั๋วเงิน
      Bill: this.state.tbBill,
      // setdefult บัตรเครดิต
      Credit: this.state.tbcredit,
      // setdefult รายได้อื่นๆ
      tbincome: this.state.tbincome,
      // setdefult ค่าใช้จ่ายอื่นๆ
      tbexpenses: this.state.tbexpenses,
    };
    this.setState({ DataSavemoney: DataSavemoney });
    this.setState({ typeFullScreenDialog: "SaveMoney" });
    this.setState({ titleFullScreenDialog: "บันทึกรับเงิน" });
    this.setState({ openFullScreenDialog: true });
  };
  CloseDialog = () => {
    this.setState({ openFullScreenDialog: false });
  };
  SELECTPROJECT = (cell, row, enumObject, rowIndex) => {
    var btnShow = "";
    if (row.T_Code) {
      btnShow = (
        <div>
          <SelectDatas
            origin="PROJECT" // ประเภท
            valueSelect={(e) =>
              this.SelectSetData("PROJECT", e, String(rowIndex))
            } // รับค่ากลับ
            title="-"
            defaultselect={row.PROJECT} // ค่าเริ่มต้นของ ประเภทราคา
            opentitle={true}
          />
        </div>
      );
    }
    return <div>{btnShow}</div>;
  };

  CloseReportDialog = (e) => {
    this.setState({ openReportFullScreenDialog: e });
    this.ReplacePage(window.location.pathname + location.search);
  };

  render() {
    const cellEditProp = {
      mode: "click",
      blurToSave: true,
      afterSaveCell: this.afterSaveCell,
      blurToSave: true,
      selected: this.state.selected,
    };
    const options = {
      onRowClick: this.onRowClick,
      onMouseLeave: this.onMouseLeave,
      insertBtn: this.createCustomInsertButton,
    };
    const type = this.state.typeFullScreenDialog;
    return (
      <div
        className="PSApp"
        onClick={this.onClick}
        onKeyDown={this.onKeyDown}
        onChange={this.onChange}
        // onBlur={this.onBlur}
      >
        <FullScreenDialognew
          open={this.state.openReportFullScreenDialog}
          title={this.state.titleReportFullScreenDialog}
          CloseDialog={(e) => this.CloseReportDialog(e)}
        >
          <Repostview url={this.state.urlsend} />
        </FullScreenDialognew>

        <Backdrop open={this.state.openBackdrop} />
        <FullScreenDialog
          open={this.state.openFullScreenDialog}
          title={this.state.titleFullScreenDialog}
          closeDialog={(e) => this.CloseDialog(e)}
        >
          {type === "search" ? (
            <Rechecked Dataselect={(e) => this._reCHK(e)} from="CSARDEPOSIT" />
          ) : null}
          {type === "Inputmultipletax" ? (
            <PopUpMultipletax
              parm={this.state.dataMultipletax}
              taxgroup={this.state.taxgroup}
              resdata={(e) => this.ReturnData(e)}
              closePopup={(e) => this.setState({ openFullScreenDialog: false })}
              recheckeddata={this.state.resrecheckeddata}
              from="CSARDEPOSIT"
            />
          ) : null}
          {type === "SaveMoney" ? (
            <PopUpSaveMoney
              closePopup={this.Switch_PopUpSaveMoney}
              AmountPayable={this.state.AmountPayable}
              DataSavemoney={this.state.DataSavemoney}
              date={this.state.Docdate}
              Customer={this.CustomerCode.current.value}
              from="CSARDEPOSIT"
              get_PopUpSaveMoney={this._get_PopUpSaveMoney}
              pms="R|1|1|1|1|1|1"
              recheckeddata={this.state.resrecheckeddata}
              depositpayment={"0"}
            />
          ) : null}
          {type === "Search_ARCode" ? (
            <PopupArcode
              closePopup={(e) => this.CloseDialog(e)}
              Get_PopUparcode={this.Get_PopUparcode}
            />
          ) : null}
          {type === "Groupdata" ||
          type === "Department" ||
          type === "Branch" ? (
            <PopUpOther
              closePopup={(e) => this.CloseDialog(e)}
              type={this.state.OtPopupType}
              Get_PopUpOther={this.Get_PopUpOther}
              userSite={this.state.siteCodeUser}
              from="CSARDEPOSIT"
            />
          ) : null}
          {type === "Search_Table" ? (
            <PopUpOther2
              Get_PopUpOther2={this.Get_PopUpOther2}
              type={this.state.PopUpTYpe}
              from="CSARDEPOSIT"
            />
          ) : null}
          {type === "Departmenttb" || type === "Branchtb" ? (
            <PopUpOtherDB
              closePopup={(e) => this.CloseDialog(e)}
              Get_PopUpOther={this.Get_PopUpDB}
              type={this.state.PopUpTYpe}
              userSite={this.state.siteCodeUser}
              from="CSARDEPOSIT"
            />
          ) : null}
        </FullScreenDialog>
        {this.state.showform ? (
          <PopUpReport close={this.switchshowform} url={this.state.urlsend} />
        ) : null}
        <div className="displaymain">
          <Topbar
            listmenu={listmenu}
            title="บันทึกรับเงินมัดจำ"
            onClick={(e) => this.onClickTopbar(e)}
          />
          <div className="PSAppfrom">
            <Grid>
              <Col xs={12} sm={12} md={12} lg={12}>
                <Row className="show-grid">
                  <Col xs={12} sm={4} md={4} lg={4}>
                    <Row className="show-grid">
                      <div className="form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <span className="input-group-addon">
                            {" "}
                            รหัสลูกหนี้{" "}
                          </span>
                          <input
                            id="CustomerCode"
                            type="text"
                            className="form-control "
                            name="CustomerCode"
                            ref={this.CustomerCode}
                          />
                          <span
                            id="CustomerCode1"
                            className="input-group-addon icon"
                            onClick={() =>
                              this.Switch_PopupArcode("Search_ARCode")
                            }
                          >
                            <i>
                              {" "}
                              <ArrowDropDownRoundedIcon fontSize="small" />
                            </i>
                          </span>
                        </div>
                      </div>
                    </Row>
                  </Col>
                  <Col xs={12} sm={8} md={8} lg={8}>
                    <Row className="show-grid">
                      <div className="form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <span
                            id="iconCustomerName"
                            className="input-group-addon icon"
                          >
                            {" "}
                            <i className="fas fa-user"></i>
                          </span>
                          <input
                            id="CustomerName"
                            type="text"
                            className="form-control "
                            ref={this.CustomerName}
                            name="CustomerName"
                            readOnly
                          />
                        </div>
                      </div>
                    </Row>
                  </Col>
                  <Col xs={12} sm={4} md={4} lg={4}>
                    <Row className="show-grid">
                      <MaterialUIPickers
                        title="วันที่เอกสาร"
                        DateValue={(e) => this.SelectSetData("Calendar1", e)}
                        defaultdate={this.state.Docdate}
                        open={this.state.checkenableInput["DOCDATE"]}
                      />
                    </Row>
                  </Col>
                  <Col xs={12} sm={4} md={4} lg={4}>
                    <Row className="show-grid">
                      <div className="form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <span className="input-group-addon">
                            {" "}
                            กลุ่มข้อมูล{" "}
                          </span>
                          <input type="hidden" ref={this.Groupdata_code} />
                          <input
                            id="Groupdata"
                            type="text"
                            className="form-control "
                            name="Groupdata"
                            ref={this.Groupdata}
                          />
                          <span
                            id="Docgroup1"
                            className="input-group-addon icon"
                            onClick={this.Switch_OtherPopup.bind(
                              null,
                              "Groupdata"
                            )}
                          >
                            <i>
                              {" "}
                              <ArrowDropDownRoundedIcon fontSize="small" />
                            </i>
                          </span>
                        </div>
                      </div>
                    </Row>
                  </Col>
                  <Col xs={12} sm={4} md={4} lg={4}>
                    <Row className="show-grid">
                      <div className="form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <span className="input-group-addon">
                            {" "}
                            เลขที่เอกสาร{" "}
                          </span>
                          <input
                            id="DeliNumber"
                            type="text"
                            className="form-control "
                            name="DeliNumber"
                            ref={this.DeliNumber}
                            disabled
                          />
                          <span
                            id="iconTaxNumber"
                            className="input-group-addon icon"
                          >
                            <i
                              className="fas fa-sync-alt"
                              onClick={() => this.Chackdoc()}
                            ></i>
                          </span>
                        </div>
                      </div>
                    </Row>
                  </Col>
                  <Col xs={12} sm={12} md={12} lg={12}>
                    <Row className="show-grid">
                      <div className="form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <span className="input-group-addon"> หมายเหตุ </span>
                          <input
                            id="remark"
                            type="text"
                            className="form-control "
                            name="remark"
                            ref={this.remark}
                          />
                        </div>
                      </div>
                    </Row>
                  </Col>
                  <Col xs={12} sm={4} md={4} lg={4}>
                    <Row className="show-grid">
                      <div className="form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <SelectDatas
                            origin="PriceType" // ประเภท
                            valueSelect={(e) =>
                              this.SelectSetData("PriceType", e)
                            } // รับค่ากลับ
                            title="ประเภทราคา"
                            defaultselect={this.state.PriceType_code} // ค่าเริ่มต้นของ ประเภทราคา
                          />
                        </div>
                      </div>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Grid>
          </div>
          <div className="container-fluid">
            <div className="PSAppTable">
              <BootstrapTable
                //bordered={ false }
                data={this.state.tableData}
                cellEdit={cellEditProp}
                //selectRow={ selectRowProp }
                options={options}
                trClassName="trClassName"
                tableHeaderClass="trClassName"
                height="400"
              >
                <TableHeaderColumn
                  row="0"
                  rowSpan="2"
                  dataField="C0"
                  isKey
                  width="30"
                  dataAlign="center"
                ></TableHeaderColumn>
                <TableHeaderColumn
                  row="0"
                  colSpan="2"
                  headerAlign="center"
                  className="colbuttomhidden"
                >
                  รหัส
                </TableHeaderColumn>
                <TableHeaderColumn
                  row="1"
                  dataField="T_Code"
                  width="120"
                  editable={this.state.Colcode}
                  dataAlign="left"
                ></TableHeaderColumn>
                <TableHeaderColumn
                  row="1"
                  dataField="BTN_Code"
                  width="30"
                  editable={false}
                  dataAlign="left"
                  dataFormat={this._cellButton.bind(this)}
                  columnClassName="columnClassNameFormat1" /* hidden={this.state.C1_hiden} */
                ></TableHeaderColumn>
                <TableHeaderColumn
                  row="0"
                  rowSpan="2"
                  dataAlign="left"
                  dataField="T_List"
                  width="140"
                  editable={this.state.Colall}
                >
                  {" "}
                  รายการ{" "}
                </TableHeaderColumn>
                <TableHeaderColumn
                  row="0"
                  rowSpan="2"
                  dataAlign="left"
                  dataField="T_Explain"
                  width="140"
                  editable={this.state.Colall}
                >
                  {" "}
                  อธิบายเพิ่มเติม
                </TableHeaderColumn>
                <TableHeaderColumn
                  row="0"
                  rowSpan="2"
                  dataAlign="reight"
                  dataField="T_Amount"
                  width="100"
                  editable={this.state.Colall}
                >
                  {" "}
                  จำนวนเงิน
                </TableHeaderColumn>
                <TableHeaderColumn
                  row="0"
                  colSpan="2"
                  dataAlign="center"
                  className="colbuttomhidden"
                >
                  {" "}
                  แผนก
                </TableHeaderColumn>
                <TableHeaderColumn
                  row="1"
                  dataField="T_Department"
                  width="80"
                  editable={this.state.Colall}
                  dataAlign="left"
                ></TableHeaderColumn>
                <TableHeaderColumn
                  row="1"
                  dataField="BTN_Department"
                  width="30"
                  editable={false}
                  dataAlign="left"
                  dataFormat={this._cellButton2.bind(this)}
                  columnClassName="columnClassNameFormat1"
                  hidden={this.state.C5_hiden}
                ></TableHeaderColumn>
                <TableHeaderColumn
                  row="0"
                  rowSpan="2"
                  dataField="PROJECT"
                  editable={false}
                  dataAlign="center"
                  dataFormat={this.SELECTPROJECT.bind(this)}
                  width="150"
                >
                  <div align="center"> โครงการ </div>
                </TableHeaderColumn>
                <TableHeaderColumn
                  row="0"
                  colSpan="2"
                  width="130"
                  dataAlign="center"
                  className="colbuttomhidden"
                >
                  {" "}
                  สาขา <i id="t_sitecode" style={{ fontSize: "10px" }}></i>
                </TableHeaderColumn>
                <TableHeaderColumn
                  row="1"
                  dataField="T_Branch"
                  width="100"
                  editable={this.state.Colall}
                  dataAlign="left"
                ></TableHeaderColumn>
                <TableHeaderColumn
                  row="1"
                  dataField="BTN_Branch"
                  width="30"
                  editable={false}
                  dataAlign="left"
                  dataFormat={this._cellButton3.bind(this)}
                  columnClassName="columnClassNameFormat1"
                  hidden={this.state.C6_hiden}
                ></TableHeaderColumn>
                <TableHeaderColumn
                  row="0"
                  rowSpan="2"
                  dataAlign="center"
                  dataField="BTN_T"
                  width="40"
                  editable={false}
                  dataFormat={this.cellcheckbok.bind(this)}
                >
                  {" "}
                  T
                </TableHeaderColumn>
                <TableHeaderColumn
                  row="0"
                  rowSpan="2"
                  dataAlign="center"
                  dataField="BTN_W"
                  width="40"
                  editable={false}
                  dataFormat={this.cellcheckbok2.bind(this)}
                >
                  {" "}
                  W{" "}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField="T_Department_Code"
                  hidden
                ></TableHeaderColumn>
                <TableHeaderColumn
                  dataField="T_Branch_Code"
                  hidden
                ></TableHeaderColumn>
                <TableHeaderColumn
                  row="0"
                  dataField="PROJECTCODE"
                  editable={false}
                  dataAlign="center"
                  width="150"
                  hidden
                >
                  {" "}
                  รหัสโครงการ{" "}
                </TableHeaderColumn>
              </BootstrapTable>
            </div>
            <Grid>
              <Col xs={12} sm={8} md={8} lg={8}>
                <Row className="show-grid">
                  <Col xs={12} sm={6} md={6} lg={6}>
                    <Row className="show-grid">
                      <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <span className="input-group-addon"> พนักงาน </span>
                          <input
                            type="text"
                            className="form-control hidden"
                            ref={this.Csuser_code}
                          />
                          <input
                            id="Csuser"
                            type="text"
                            className="form-control "
                            name="Csuser"
                            ref={this.Csuser}
                            readOnly
                          />
                          <span
                            id="iconTaxNumber"
                            className="input-group-addon icon"
                          >
                            <i
                              className="fas fa-sync-alt"
                              onClick={() =>
                                this.onAddValue(
                                  "Csuser",
                                  this.state.siteCodeUser1
                                )
                              }
                            ></i>
                          </span>
                        </div>
                      </div>
                      <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <span className="input-group-addon"> แผนก </span>
                          <input
                            type="text"
                            className="form-control hidden"
                            ref={this.Department_code}
                          />
                          <input
                            id="Department"
                            type="text"
                            className="form-control "
                            name="Department"
                            ref={this.Department}
                          />
                          <span
                            id="CSDEPARTMENT"
                            className="input-group-addon icon"
                            onClick={this.Switch_OtherPopup.bind(
                              null,
                              "Department"
                            )}
                          >
                            <i>
                              {" "}
                              <ArrowDropDownRoundedIcon fontSize="small" />
                            </i>
                          </span>
                        </div>
                      </div>
                      <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                          <SelectDatas
                            origin="PROJECT" // โครงการ
                            valueSelect={(e) =>
                              this.SelectSetData("PROJECT", e, "")
                            } // รับค่ากลับ
                            title="โครงการ"
                            defaultselect={this.state.PROJECT} // ค่าเริ่มต้นของ โครงการ
                          />
                        </div>
                      </div>
                      <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <span className="input-group-addon"> สาขา </span>
                          <input
                            type="text"
                            className="form-control hidden"
                            ref={this.Branch_code}
                          />
                          <input
                            id="Branch"
                            type="text"
                            className="form-control "
                            name="Branch"
                            ref={this.Branch}
                          />
                          <span
                            id="Branch"
                            className="input-group-addon icon"
                            onClick={this.Switch_OtherPopup.bind(
                              null,
                              "Branch"
                            )}
                          >
                            <i>
                              {" "}
                              <ArrowDropDownRoundedIcon fontSize="small" />
                            </i>
                          </span>
                        </div>
                      </div>
                    </Row>
                  </Col>
                  <Col xs={12} sm={6} md={6} lg={6}>
                    <Row className="show-grid">
                      <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                          <span className="input-group-addon">
                            หัก ณ ที่จ่าย{" "}
                          </span>
                          <input
                            type="text"
                            className="form-control Price"
                            ref={this.WTAXAMOUNT}
                            value="0.00"
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                          <span className="input-group-addon">สกุลเงิน </span>
                          <input
                            type="text"
                            className="form-control"
                            value="บาท"
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                          <span className="input-group-addon">
                            อัตราแลกเปลี่ยน{" "}
                          </span>
                          <input
                            type="text"
                            className="form-control Price"
                            value="1.0000000"
                            readOnly
                          />
                        </div>
                      </div>
                    </Row>
                  </Col>
                  <Col xs={12} sm={12} md={12} lg={12}>
                    <Row className="show-grid"></Row>
                  </Col>
                  <Col xs={12} sm={6} md={6} lg={6}>
                    <Row className="show-grid"></Row>
                  </Col>
                  <Col xs={12} sm={6} md={6} lg={6}>
                    <Row className="show-grid"></Row>
                  </Col>
                </Row>
              </Col>
              <Col xs={12} sm={4} md={4} lg={4}>
                <Row className="show-grid">
                  <Col xs={12} sm={12} md={12} lg={12}>
                    <Row className="show-grid">
                      <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <span className="input-group-addon ">
                            {" "}
                            รวมจำนวนเงิน{" "}
                          </span>
                          <input
                            id="SumPrice"
                            type="text"
                            className="form-control Price"
                            name="SumPrice"
                            ref={this.SumPrice}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <span className="input-group-addon ">
                            {" "}
                            ภาษีมูลค่าเพิ่ม{" "}
                          </span>
                          <input
                            id="TaxPersen"
                            type="text"
                            className="form-control Price"
                            ref={this.TaxPersen}
                            name="TaxPersen"
                            onClick={(e) => {
                              e.target.value = Number(e.target.value);
                            }}
                            onKeyDown={this.Cal_Price1}
                            onBlur={this.Cal_Price.bind(null)}
                          />
                          <span className="input-group-addon icon"> % </span>
                          <input
                            id="TaxPrice"
                            type="text"
                            className="form-control Price"
                            ref={this.TaxPrice}
                            name="TaxPrice"
                            value={this.state.Taxamount}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <span className="input-group-addon">
                            {" "}
                            มูลค่ารวมภาษี{" "}
                          </span>
                          <input
                            id="valueTax"
                            type="text"
                            className="form-control Price"
                            name="valueTax"
                            ref={this.valueTax}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <span className="input-group-addon  ">
                            {" "}
                            มูลค่ายกเว้น{" "}
                          </span>
                          <input
                            id="ValueExcept"
                            type="text"
                            className="form-control Price"
                            ref={this.ValueExcept}
                            name="ValueExcept"
                            value={this.state.Sumamount2}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="form-group input-Bottom col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div className="input-group col-xs-12 col-sm-12 col-md-12 col-lg-12">
                          <span className="input-group-addon  ">
                            {" "}
                            เงินรวมทั้งสิ้น{" "}
                          </span>
                          <input
                            id="TotalPrice"
                            type="text"
                            className="form-control Price"
                            ref={this.TotalPrice}
                            name="TotalPrice"
                            value={this.state.Debtamount}
                            disabled
                          />
                        </div>
                      </div>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Row className="show-grid">
                <Col xs={12} sm={12} md={12} lg={12}>
                  <Panel>
                    <Panel.Heading>
                      <Panel.Title componentClass="h5">
                        ข้อมูลเพิ่มเติม ( User's Field){" "}
                      </Panel.Title>
                    </Panel.Heading>
                    <Panel.Body>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
                          <InputTemplate title="รหัสลูกค้า">
                            <input
                              type="text"
                              className="form-control "
                              ref={this.PS_arcode}
                            />
                          </InputTemplate>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
                          <InputTemplate title="ชื่อลูกค้า">
                            <input
                              type="text"
                              className="form-control "
                              ref={this.arname2}
                            />
                          </InputTemplate>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
                          <InputTemplate title="เลขที่สัญญา">
                            <input
                              type="text"
                              className="form-control "
                              ref={this.Contractno}
                            />
                          </InputTemplate>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
                          <InputTemplate title="ทะเบียนรถ">
                            <input
                              type="text"
                              className="form-control "
                              ref={this.Register}
                            />
                          </InputTemplate>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
                          <InputTemplate title="สกุล">
                            <input
                              type="text"
                              className="form-control "
                              ref={this.Lastname}
                            />
                          </InputTemplate>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
                          <CustomDatePicker
                            title="วันครบกำหนด"
                            DateValue={(e) =>
                              this.setState({
                                DueCustOrder:
                                  e !== null
                                    ? Moment(e).format("YYYY-MM-DD")
                                    : null,
                              })
                            }
                            defaultdate={null}
                          />
                        </Grid>
                      </Grid>
                    </Panel.Body>
                  </Panel>
                </Col>
              </Row>
            </Grid>
            <Snackbar
              place="br"
              color={this.state.color}
              icon={this.state.icon}
              autoClose={this.state.autoClose}
              message={this.state.messagealert}
              open={this.state.opensnackbar}
              closeNotification={() => {
                this.setState({ opensnackbar: false });
              }}
              close
            />
          </div>
        </div>
      </div>
    );
  }
}
